const getGoogleMapConfig = (googleMapContainer) => {
  if (!googleMapContainer) return null;

  const latString = googleMapContainer.getAttribute("data-lat");
  const lngString = googleMapContainer.getAttribute("data-lng");
  const mapId = googleMapContainer.getAttribute("data-map-id");

  if (!latString || !lngString || !mapId) return null;

  return {
    center: {
      lat: parseFloat(latString),
      lng: parseFloat(lngString),
    },
    mapId,
    radiusMiles: parseInt(googleMapContainer.getAttribute("data-range-miles")) || 0,
    showPin: googleMapContainer.getAttribute("data-show-pin") === "true",
  };
};

export const initializeGoogleMap = async ({
  googleMapContainer,
  loader,
  googleMaps,
  getGoogleMaps = () => googleMaps,
  querySelector = (selector) => document.querySelector(selector),
  consoleError = console.error,
}) => {
  const config = getGoogleMapConfig(googleMapContainer);

  if (!config) {
    return {loaded: false};
  }

  try {
    await loader.load();

    const mapsApi = getGoogleMaps();

    if (!mapsApi) {
      throw new ReferenceError("google is not defined");
    }

    const {Map} = await mapsApi.importLibrary("maps");

    googleMapContainer.classList.remove("animate-pulse");

    const map = new Map(googleMapContainer, {
      mapId: config.mapId,
      center: config.center,
      zoom: 6,
    });

    if (config.showPin) {
      const {AdvancedMarkerElement} = await mapsApi.importLibrary("marker");

      new AdvancedMarkerElement({
        map,
        position: config.center,
        title: "Title",
      });
    }

    if (config.radiusMiles) {
      const primaryBackground = querySelector("meta[name=\"primary-background\"]")?.getAttribute("content") || "#3472C6";

      new mapsApi.Circle({
        map,
        center: config.center,
        radius: config.radiusMiles * 1609.34,
        fillColor: primaryBackground,
        fillOpacity: 0.2,
        strokeColor: primaryBackground,
        strokeOpacity: 0.75,
        strokeWeight: 2,
      });
    }

    return {loaded: true, map};
  } catch (error) {
    consoleError(error);

    return {loaded: false, error};
  }
};
